import React from 'react';

type Props = {
  dimension?: number;
};

const Icon: React.FC<Props> = ({ dimension = 16 }: Props) => (
  <svg width={dimension} height={dimension} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_29906_2993" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <rect width={dimension} height={dimension} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_29906_2993)">
      <path
        d="M5.33333 26.6668C4.6 26.6668 3.97222 26.4057 3.45 25.8835C2.92778 25.3613 2.66666 24.7335 2.66666 24.0002V8.00016C2.66666 7.26683 2.92778 6.63905 3.45 6.11683C3.97222 5.59461 4.6 5.3335 5.33333 5.3335H26.6667C27.4 5.3335 28.0278 5.59461 28.55 6.11683C29.0722 6.63905 29.3333 7.26683 29.3333 8.00016V24.0002C29.3333 24.7335 29.0722 25.3613 28.55 25.8835C28.0278 26.4057 27.4 26.6668 26.6667 26.6668H5.33333ZM16 17.3335L5.33333 10.6668V24.0002H26.6667V10.6668L16 17.3335ZM16 14.6668L26.6667 8.00016H5.33333L16 14.6668ZM5.33333 10.6668V8.00016V24.0002V10.6668Z"
        fill="#018463"
      />
    </g>
  </svg>
);

export default Icon;
